import React from 'react';
import ArrowUp from '../../Images/chevron-up.svg';
import ArrowDown from '../../Images/chevron-down.svg';
import ArrowDefault from '../../Images/Chevron-default-icon.svg';
import Loader from '../../Components/common/loader/loader';
import type { ProfileData, ProfileSortConfig, SortableKeys } from './profileTypes';
import { isProfileStatusActive } from './profileUsers';

type Props = {
    isLoadingProfile: boolean;
    paginatedProfiles: ProfileData[];
    sortConfig: ProfileSortConfig;
    onRequestSort: (key: SortableKeys) => void;
    onProfileClick: (id: string) => void;
};

const SortHeader: React.FC<{
    label: string;
    columnKey: SortableKeys;
    className?: string;
    style?: React.CSSProperties;
    sortConfig: ProfileSortConfig;
    onRequestSort: (key: SortableKeys) => void;
}> = ({ label, columnKey, className, style, sortConfig, onRequestSort }) => {
    const getSortArrow = () => {
        if (!sortConfig || sortConfig.key !== columnKey) {
            return <img className="arrow-default" src={ArrowDefault} alt="sort" />;
        }
        if (sortConfig.direction === 'asc') {
            return <img className="arrow-up" src={ArrowUp} alt="sort asc" />;
        }
        return <img className="arrow-down" src={ArrowDown} alt="sort desc" />;
    };

    return (
        <th className={className} style={style} onClick={() => onRequestSort(columnKey)}>
            <div className="sort-header">
                <p className='customer-profile'>{label}</p>
                {getSortArrow()}
            </div>
        </th>
    );
};

const ProfileUsersTable: React.FC<Props> = ({
    isLoadingProfile,
    paginatedProfiles,
    sortConfig,
    onRequestSort,
    onProfileClick,
}) => (
    <div className="table-wrapper-profile">
        <table className="global-table profile-table">
            <thead>
                <tr>
                    <SortHeader label="Customer" columnKey="customer" className="col-customer" sortConfig={sortConfig} onRequestSort={onRequestSort} />
                    <SortHeader label="Name" columnKey="name" className="col-site" sortConfig={sortConfig} onRequestSort={onRequestSort} />
                    <SortHeader label="User Type" columnKey="type" className="col-plant-user" sortConfig={sortConfig} onRequestSort={onRequestSort} />
                    <SortHeader label="Role" columnKey="role" className="col-sales-district-user" sortConfig={sortConfig} onRequestSort={onRequestSort} />
                    <SortHeader label="Email" columnKey="email" className="col-sold-tos" sortConfig={sortConfig} onRequestSort={onRequestSort} />
                    <SortHeader label="Status" columnKey="status" className="col-status-user" style={{ width: '82px' }} sortConfig={sortConfig} onRequestSort={onRequestSort} />
                </tr>
            </thead>
            <tbody>
                {isLoadingProfile && (
                    <tr>
                        <td colSpan={6} className="table-loading">
                            <Loader />
                        </td>
                    </tr>
                )}
                {!isLoadingProfile && paginatedProfiles.length > 0 && paginatedProfiles.map((profile) => (
                    <tr key={profile.id}>
                        <td className="text-wrap" title={profile.customer}>
                            {profile.customer}
                        </td>
                        <td className="text-wrap">
                            <button
                                type="button"
                                onClick={() => onProfileClick(profile.id)}
                                className="content-link"
                                title={profile.name}
                            >
                                {profile.name}
                            </button>
                        </td>
                        <td className="text-wrap-type" title={profile.type}>
                            {profile.type}
                        </td>
                        <td className="text-wrap-role" title={profile.role}>
                            {profile.role}
                        </td>
                        <td className="text-wrap" title={profile.email}>
                            {profile.email}
                        </td>
                        <td
                            className={`content-status ${
                                isProfileStatusActive(profile.status)
                                    ? 'status-active profile-active-user'
                                    : 'profile-inactive-user'
                            }`}
                            title={profile.status}
                        >
                            <span className='status-text'>{profile.status}</span>
                        </td>
                    </tr>
                ))}
                {!isLoadingProfile && paginatedProfiles.length === 0 && (
                    <tr>
                        <td colSpan={6} className="table-empty">No data found</td>
                    </tr>
                )}
            </tbody>
        </table>
    </div>
);

export default ProfileUsersTable;
